import { render, staticRenderFns } from "./DialogRegister.vue?vue&type=template&id=7a5fbf65&"
import script from "./DialogRegister.vue?vue&type=script&lang=js&"
export * from "./DialogRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports